(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-more-text"]) return;
  try {
    
jQuery(document).ready(function(){
jQuery('.readmore').click(function (readmoreevent) {
  readmoreevent.preventDefault();
  jQuery('.product-description-full').show();
  jQuery('.product-description-short').hide()

  })
  jQuery('.readless').click(function (readmoreevent) {
  readmoreevent.preventDefault();
  jQuery('.product-description-full').hide();
  jQuery('.product-description-short').show()
  })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
    jQuery(".readmore_btn").click(function(){

      jQuery(".bottom-content div.btm_hide").css("display", "block");
      jQuery(".bottom-content .readless_btn").css("display", "block");
      jQuery(".bottom-content .readmore_btn").css("display", "none");

    });

    jQuery(".readless_btn").click(function(){

        jQuery(".bottom-content div.btm_hide").css("display", "none");
        jQuery(".bottom-content .readmore_btn").css("display", "block");
        jQuery(".bottom-content .readless_btn").css("display", "none");

    });
    jQuery('.js-load-more').on('click', function(e){
     e.preventDefault();
     var jQuerythis =jQuery(this),
     //alert('test');
     totalPages = parseInt(jQuery('[data-all-pages]').val()),
     currentPage = parseInt(jQuery('[data-this-page]').val()),
     datacollurl = jQuery('[data-coll-url]').val();;
     jQuerythis.attr('disabled', true);
     jQuerythis.find('[load-more-text]').addClass('hide');
     jQuery('span[loader]').removeClass('hide');
     var nextUrl = jQuery('[data-next-link]').val();
     var current_page_new = currentPage + 1;
     var next_coll = currentPage + 2;
     //alert(current_page_new)
     //return false;
     jQuery.ajax({
     url: nextUrl,
     type: 'GET',
     dataType: 'html',
     success: function(responseHTML){
     jQuery('[data-next-link]').val(datacollurl + "?page="+next_coll);
     jQuery('[data-this-page]').val(current_page_new);
     jQuery('.collection-grid').append(jQuery(responseHTML).find('.collection-grid').html());
     },
     complete: function() {
     if(current_page_new < totalPages) {
     jQuerythis.attr('disabled', false); jQuerythis.find('[load-more-text]').removeClass('hide'); jQuery('span[loader]').addClass('hide');
     }
     if(current_page_new >= totalPages) {
     jQuerythis.find('[load-more-text]').text('Products Finished').removeClass('hide'); jQuery('span[loader]').addClass('hide');
     }
     }
     })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // jQuery(document).ready(function() {
  //   setTimeout(function() {
  //     jQuery('.sls-option').click();
  //   }, 5000);
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-content"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function(){
jQuery('.vreadmore').click(function (vreadmoreevent) {
  vreadmoreevent.preventDefault();
  jQuery('.video-description-full').show();
  jQuery('.video-description-short').hide()
  })
  jQuery('.vreadless').click(function (vreadmoreevent) {
  vreadmoreevent.preventDefault();
  jQuery('.video-description-full').hide();
  jQuery('.video-description-short').show()
  })
});

  } catch(e) { console.error(e); }
})();
})();
